import React, { Component } from "react";
import { TITIK_BACA_KATEGORI, TITIK_BACA } from "../api";
import {
  executeGet,
  executePost,
  formatTanggal,
  goBack,
} from "../functions/Kubuku";
import { useParams, useNavigate } from "react-router-dom";
import Masonry from "react-masonry-css";
import { disableSplashScreen } from "../api/enkripsi";

function WithNavigate(props) {
  let navigate = useNavigate();
  return <ListBuku {...props} navigate={navigate} params={useParams()} />;
}

class ListBuku extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      showMain: false,
      params: this.props.params,
      dataBerita: "",
      alias: window.localStorage.getItem("alias"),
      lokasi: "",
      lat: "-7.557130246009252",
      long: "110.79448368501073",
      alt: 1,
      jauh: false,
      msgJauh: "",
      lokasiMsgJauh: "",
      alt: "1",
      flagData: false,
      dataTop: [],
      hal: 1,
      mode: 0,
      search: "",
      flagNoData: false,
      msgTitleNoData: "Buku Tidak Ditemukan",
      msgNoData: "Buku yang anda cari tidak ditemukan, silahkan cari buku lain",
    };
  }

  componentDidMount = async () => {
    disableSplashScreen();
    this.setState({
      alias: window.localStorage.getItem("alias"),
    });
    this.getLocation();
  };

  getLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      let long = position.coords.longitude;
      let lat = position.coords.latitude;
      let alt = position.coords.altitude;
      this.setState({
        lat: lat,
        long: long,
        alt: alt,
      });
      this.getBukuKategori(lat, long, alt);
    });
  };

  btnCari = async () => {
    this.setState({
      mode: 0,
      hal: 1,
      dataTop: [],
    });
    this.cariBuku();
  };

  btnNext = async (lat, long, alt) => {
    let mode = this.state.mode;
    if (mode == 0) {
      this.cariBuku();
    } else {
      this.getBukuKategori(lat, long, alt);
    }
  };

  cariBuku = async () => {
    try {
      let ldata = this.state.dataTop;
      let hal = parseInt(this.state.hal);
      let alias = window.localStorage.getItem("alias");
      let formData = new FormData();
      formData.append("latitude", this.state.lat);
      formData.append("longitude", this.state.long);
      formData.append("altitude", this.state.altitude);
      formData.append("isMobile", "1");
      formData.append("search", this.state.search);
      formData.append("tipe", this.props.params.tipe);
      formData.append("hal", hal);
      const json = await executePost(
        TITIK_BACA + alias + "/searchingFromIndex",
        formData
      );
      if (json.code == 200) {
        if (json.data.length > 0) {
          this.setState({
            dataTop: ldata.concat(json.data),
            flagData: true,
            flagNoData: false,
            hal: hal + 1,
          });
        } else {
          this.setState({
            dataTop: json.data,
            flagData: false,
            flagNoData: true,
          });
        }
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  getBukuKategori = async (lat, long, alt) => {
    try {
      this.setState({
        mode: 1,
      });
      let hal = parseInt(this.state.hal);
      let ldata = this.state.dataTop;
      let alias = window.localStorage.getItem("alias");
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", hal);
      formData.append("kategori", this.state.params.kategori);
      const json = await executePost(TITIK_BACA_KATEGORI + alias, formData);
      if (json.code == 200) {
        this.setState({
          dataTop: ldata.concat(json.data),
          flagData: true,
          judul: "Kategori " + this.state.params.kategori,
          hal: hal + 1,
        });
      } else if (json.code == 400) {
        var parsingMsg = json.msg.substr(0, json.msg.indexOf("<p>"));
        var parsingMsg2 = parsingMsg.replace(/,\s*$/, "");
        // var parsingMsg2 = parsingMsg.substr(0, parsingMsg.indexOf(','));
        this.setState({
          jauh: true,
          flagData: false,
          //isLoading: false,
          msgJauh: parsingMsg2,
          lokasiMsgJauh: json.google_maps,
          lokasi: json.nama_lokasi,
        });
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  gotoDetail = async (id) => {
    window.location.href = "/detailBuku/" + id + "/" + this.state.alias;
  };

  render() {
    return (
      <div className="mb-16">
        <div className="shadow-md p-3">
          <div className="flex items-center">
            <div className="flex-0">
              <svg
                onClick={() => goBack()}
                width="34"
                height="34"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-2"
              >
                <path
                  d="M11.0303 8.53033C11.3232 8.23744 11.3232 7.76256 11.0303 7.46967C10.7374 7.17678 10.2626 7.17678 9.96967 7.46967L5.96967 11.4697C5.82322 11.6161 5.75 11.8081 5.75 12C5.75 12.1017 5.77024 12.1987 5.80691 12.2871C5.84351 12.3755 5.89776 12.4584 5.96967 12.5303L9.96967 16.5303C10.2626 16.8232 10.7374 16.8232 11.0303 16.5303C11.3232 16.2374 11.3232 15.7626 11.0303 15.4697L8.31066 12.75H18C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H8.31066L11.0303 8.53033Z"
                  fill="#383838"
                />
              </svg>
            </div>
            <div className="flex-1">
              <div className="relative">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="absolute top-3 left-[16px] mr-2"
                >
                  <path
                    d="M9.33512 4.80232C9.74423 4.73752 10.0234 4.35334 9.95856 3.94423C9.89376 3.53511 9.50958 3.25599 9.10047 3.32079C6.64008 3.71047 4.71044 5.64012 4.32076 8.1005C4.25596 8.50961 4.53508 8.89379 4.9442 8.95859C5.35331 9.02339 5.73749 8.74426 5.80229 8.33515C6.09032 6.51661 7.51658 5.09035 9.33512 4.80232Z"
                    fill="#d3d3d3"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 0.25C5.61522 0.25 1.25 4.61522 1.25 10C1.25 15.3848 5.61522 19.75 11 19.75C16.3848 19.75 20.75 15.3848 20.75 10C20.75 4.61522 16.3848 0.25 11 0.25ZM2.75 10C2.75 5.44365 6.44365 1.75 11 1.75C15.5563 1.75 19.25 5.44365 19.25 10C19.25 14.5563 15.5563 18.25 11 18.25C6.44365 18.25 2.75 14.5563 2.75 10Z"
                    fill="#d3d3d3"
                  />
                  <path
                    d="M19.5304 17.4698C19.2375 17.1769 18.7626 17.1769 18.4697 17.4698C18.1768 17.7626 18.1768 18.2375 18.4697 18.5304L22.4696 22.5304C22.7625 22.8233 23.2374 22.8233 23.5303 22.5304C23.8232 22.2375 23.8232 21.7626 23.5303 21.4697L19.5304 17.4698Z"
                    fill="#d3d3d3"
                  />
                </svg>
                <input
                  type="text"
                  onChange={(event) => {
                    this.setState({ search: event.target.value });
                  }}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      this.btnCari();
                    }
                  }}
                  className="flex items-center w-full pr-4 pl-11 py-2.5 bg-white border border-gray-200 rounded-2xl placeholder:text-gray-400 text-sm focus:outline-none focus:border-orange focus:ring-orange"
                  placeholder="Cari judul buku, penulis, penerbit..."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center px-4 mt-2 line-clamp-1">
          <h3 className="text-base text-black font-semibold">
            {this.state.judul}
          </h3>
        </div>
        {this.state.jauh && (
          <>
            {/* End Section Hero */}
            <div className="mt-16">
              <div className="px-4">
                <div className="relative mb-2.5 p-4 bg-orange text-white rounded-2xl shadow-md overflow-hidden">
                  <div className="w-52 sm:w-96 md:w-auto">
                    <p className="mb-3 text-sm font-semibold">
                      {this.state.msgJauh}
                    </p>
                    <a
                      type="button"
                      href={this.state.lokasiMsgJauh}
                      className="py-1 px-6 border border-white text-sm font-semibold rounded-full"
                    >
                      Lokasi Anda
                    </a>
                  </div>
                  <svg
                    width="64"
                    height="68"
                    viewBox="0 0 64 68"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute right-2.5 top-1 z-10"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.6379 67.2934C11.1472 67.2934 24.8452 63.913 24.8452 63.913L38.4521 62.7157L55.4457 62.4841L49.3253 29.5515L45.2892 20.5968L10.6379 62.3136C10.6379 62.3136 9.344 67.2934 10.6379 67.2934Z"
                      fill="url(#paint0_linear_176_439)"
                    />
                    <mask
                      id="path-2-outside-1_176_439"
                      maskUnits="userSpaceOnUse"
                      x="1.61022"
                      y="15.8526"
                      width="52.6296"
                      height="52.6296"
                      fill="black"
                    >
                      <rect
                        fill="white"
                        x="1.61022"
                        y="15.8526"
                        width="52.6296"
                        height="52.6296"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M32.515 24.8062L45.4709 18.1441C45.6726 18.0404 45.9167 18.1642 45.9522 18.3882L51.6594 54.4217C51.6819 54.5638 51.6106 54.7043 51.4827 54.7701L38.4566 61.4683C38.4141 61.4901 38.3697 61.5019 38.3257 61.5047C38.2838 61.515 38.2388 61.5173 38.1926 61.5098L23.8116 59.1773L10.8553 65.8397C10.6536 65.9434 10.4094 65.8196 10.3739 65.5955L4.66678 29.562C4.64427 29.42 4.71552 29.2795 4.84346 29.2137L17.8696 22.5155C17.9117 22.4938 17.9556 22.4821 17.9991 22.4791C18.0415 22.4685 18.087 22.4661 18.1337 22.4736L32.515 24.8062Z"
                      />
                    </mask>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M32.515 24.8062L45.4709 18.1441C45.6726 18.0404 45.9167 18.1642 45.9522 18.3882L51.6594 54.4217C51.6819 54.5638 51.6106 54.7043 51.4827 54.7701L38.4566 61.4683C38.4141 61.4901 38.3697 61.5019 38.3257 61.5047C38.2838 61.515 38.2388 61.5173 38.1926 61.5098L23.8116 59.1773L10.8553 65.8397C10.6536 65.9434 10.4094 65.8196 10.3739 65.5955L4.66678 29.562C4.64427 29.42 4.71552 29.2795 4.84346 29.2137L17.8696 22.5155C17.9117 22.4938 17.9556 22.4821 17.9991 22.4791C18.0415 22.4685 18.087 22.4661 18.1337 22.4736L32.515 24.8062Z"
                      fill="#ADE1F1"
                    />
                    <path
                      d="M45.4709 18.1441L46.0802 19.3291L46.0802 19.3291L45.4709 18.1441ZM32.515 24.8062L32.3016 26.1215L32.7344 26.1917L33.1243 25.9912L32.515 24.8062ZM45.9522 18.3882L44.6361 18.5967L45.9522 18.3882ZM51.6594 54.4217L52.9755 54.2133L51.6594 54.4217ZM51.4827 54.7701L50.8733 53.5851L50.8733 53.5851L51.4827 54.7701ZM38.4566 61.4683L37.8472 60.2832L37.8472 60.2832L38.4566 61.4683ZM38.3257 61.5047L38.2399 60.175L38.1219 60.1826L38.0071 60.2109L38.3257 61.5047ZM38.1926 61.5098L38.406 60.1945L38.4059 60.1945L38.1926 61.5098ZM23.8116 59.1773L24.025 57.862L23.5922 57.7918L23.2023 57.9923L23.8116 59.1773ZM10.8553 65.8397L10.2459 64.6546L10.2459 64.6546L10.8553 65.8397ZM10.3739 65.5955L9.05782 65.804L10.3739 65.5955ZM4.66678 29.562L5.98287 29.3536L4.66678 29.562ZM4.84346 29.2137L5.45281 30.3987L5.45281 30.3987L4.84346 29.2137ZM17.8696 22.5155L18.4789 23.7005L18.4789 23.7005L17.8696 22.5155ZM17.9991 22.4791L18.0902 23.8085L18.2087 23.8004L18.3238 23.7715L17.9991 22.4791ZM18.1337 22.4736L17.9204 23.789L17.9204 23.789L18.1337 22.4736ZM44.8615 16.9591L31.9056 23.6212L33.1243 25.9912L46.0802 19.3291L44.8615 16.9591ZM47.2683 18.1798C47.0909 17.0596 45.8701 16.4404 44.8615 16.9591L46.0802 19.3291C45.475 19.6403 44.7426 19.2688 44.6361 18.5967L47.2683 18.1798ZM52.9755 54.2133L47.2683 18.1798L44.6361 18.5967L50.3433 54.6302L52.9755 54.2133ZM52.092 55.9551C52.7317 55.6262 53.088 54.9237 52.9755 54.2133L50.3433 54.6302C50.2757 54.2039 50.4895 53.7824 50.8733 53.5851L52.092 55.9551ZM39.0659 62.6533L52.092 55.9551L50.8733 53.5851L37.8472 60.2832L39.0659 62.6533ZM38.4116 62.8345C38.6358 62.82 38.8587 62.7599 39.0659 62.6533L37.8472 60.2832C37.9695 60.2204 38.1035 60.1838 38.2399 60.175L38.4116 62.8345ZM37.9793 62.8251C38.2046 62.8617 38.4305 62.8512 38.6444 62.7986L38.0071 60.2109C38.1371 60.1789 38.2731 60.173 38.406 60.1945L37.9793 62.8251ZM23.5983 60.4926L37.9793 62.8251L38.4059 60.1945L24.025 57.862L23.5983 60.4926ZM11.4646 67.0247L24.421 60.3623L23.2023 57.9923L10.2459 64.6546L11.4646 67.0247ZM9.05782 65.804C9.23524 66.9242 10.456 67.5433 11.4646 67.0247L10.2459 64.6546C10.8511 64.3434 11.5836 64.7149 11.69 65.3871L9.05782 65.804ZM3.35068 29.7705L9.05782 65.804L11.69 65.3871L5.98287 29.3536L3.35068 29.7705ZM4.23412 28.0287C3.59442 28.3576 3.23815 29.06 3.35068 29.7705L5.98287 29.3536C6.05039 29.7799 5.83662 30.2013 5.45281 30.3987L4.23412 28.0287ZM17.2602 21.3305L4.23411 28.0287L5.45281 30.3987L18.4789 23.7005L17.2602 21.3305ZM17.908 21.1497C17.686 21.165 17.4655 21.2249 17.2602 21.3305L18.4789 23.7005C18.3579 23.7628 18.2252 23.7993 18.0902 23.8085L17.908 21.1497ZM18.3471 21.1583C18.119 21.1213 17.8905 21.1325 17.6744 21.1868L18.3238 23.7715C18.1925 23.8045 18.0549 23.8108 17.9204 23.789L18.3471 21.1583ZM32.7283 23.4909L18.3471 21.1583L17.9204 23.789L32.3016 26.1215L32.7283 23.4909Z"
                      fill="url(#paint1_linear_176_439)"
                      mask="url(#path-2-outside-1_176_439)"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.66673 29.5618C4.64423 29.4197 4.71548 29.2792 4.84342 29.2134L17.8695 22.5152C18.0712 22.4115 18.3154 22.5353 18.3509 22.7594L24.058 58.7928C24.0805 58.9349 24.0093 59.0754 23.8813 59.1412L10.8552 65.8394C10.6535 65.9431 10.4094 65.8193 10.3739 65.5952L4.66673 29.5618Z"
                      fill="#ADE1F1"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.09232 51.4391C8.06938 51.2967 8.14064 51.1558 8.26886 51.0898L21.2955 44.3914C21.4969 44.2878 21.7407 44.4111 21.7767 44.6346L24.0574 58.7925C24.0803 58.9349 24.0091 59.0758 23.8808 59.1418L10.8542 65.8402C10.6528 65.9438 10.409 65.8205 10.373 65.597L8.09232 51.4391Z"
                      fill="#ADF1AF"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M32.2675 25.1904C32.245 25.0483 32.3162 24.9078 32.4442 24.842L45.4703 18.1438C45.672 18.0401 45.9161 18.1639 45.9516 18.388L51.6588 54.4214C51.6813 54.5635 51.61 54.704 51.4821 54.7698L38.456 61.468C38.2542 61.5717 38.0101 61.4479 37.9746 61.2238L32.2675 25.1904Z"
                      fill="#ADE1F1"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M35.7741 47.4515L40.9383 49.9914L49.948 45.6178C50.1508 45.5193 50.3908 45.6466 50.4231 45.8697L51.6627 54.4244C51.6831 54.5652 51.6118 54.7034 51.4853 54.7684L38.4557 61.4684C38.2541 61.5721 38.0102 61.4485 37.9744 61.2247L35.7741 47.4515Z"
                      fill="#ADF1AF"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M32.8678 25.0954C32.8453 24.9533 32.7341 24.8417 32.5921 24.8187L18.1337 22.4737C17.9098 22.4373 17.7159 22.6305 17.7514 22.8546L23.4585 58.8881C23.481 59.0302 23.5922 59.1417 23.7342 59.1648L38.1926 61.5098C38.4165 61.5462 38.6104 61.3529 38.575 61.1289L32.8678 25.0954Z"
                      fill="#9AD6E9"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M32.0645 46.6664C31.9427 46.6323 31.8508 46.5321 31.8272 46.4078L30.3691 38.7273L20.521 37.13C20.2975 37.0937 20.1037 37.2862 20.1385 37.5099L23.4589 58.8872C23.481 59.0297 23.5924 59.1418 23.7347 59.1649L38.1938 61.5101C38.4173 61.5463 38.6111 61.3539 38.5763 61.1301L36.524 47.9167L32.0645 46.6664Z"
                      fill="#9AE99C"
                    />
                    <path
                      d="M7.23277 51.1431L20.676 44.7826L19.2484 36.6147L22.622 37.2337L30.6277 38.166L31.9741 46.7593L35.9355 47.4374L40.8225 49.9634L50.9682 45.1766"
                      stroke="white"
                      strokeWidth="1.99876"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.2552 39.0684L13.969 37.8863L12.7439 30.9982L15.9964 29.1204L15.2151 23.5279"
                      stroke="white"
                      strokeWidth="0.999378"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.7783 48.8492L18.4118 52.3718L22.2743 50.6138L37.0916 53.2579L38.4154 62.3491"
                      stroke="white"
                      strokeWidth="0.999378"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M31.1092 38.1142L29.9326 29.2229L33.4327 30.0079L37.9876 36.2505L45.429 32.8135L47.892 26.0709"
                      stroke="white"
                      strokeWidth="0.999378"
                      stroke-linejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M52.6699 51.4015L26.8934 38.3246L30.717 36.8811L33.2266 38.3246L44.996 21.2019H47.7272L52.6699 51.4015Z"
                      fill="url(#paint2_linear_176_439)"
                    />
                    <path
                      d="M11.3957 9.00499L7.19757 6.21516C6.75746 5.92269 6.16816 6.04226 5.88133 6.48224C5.5945 6.92222 5.71876 7.51599 6.15888 7.80846L10.357 10.5983C10.7971 10.8908 11.3864 10.7712 11.6732 10.3312C11.9601 9.89123 11.8358 9.29746 11.3957 9.00499Z"
                      fill="url(#paint3_linear_176_439)"
                    />
                    <path
                      d="M9.17086 12.5428L4.20095 11.7017C3.67993 11.6136 3.19021 11.9625 3.10714 12.4811C3.02406 12.9997 3.37909 13.4916 3.90011 13.5798L8.87002 14.4209C9.39104 14.5091 9.88075 14.1601 9.96383 13.6415C10.0469 13.1229 9.69188 12.631 9.17086 12.5428Z"
                      fill="url(#paint4_linear_176_439)"
                    />
                    <path
                      d="M15.1263 6.83111L12.8855 2.31599C12.6506 1.84264 12.0805 1.65155 11.6121 1.88917C11.1437 2.12679 10.9544 2.70314 11.1893 3.17648L13.4301 7.6916C13.665 8.16495 14.2352 8.35604 14.7036 8.11842C15.1719 7.8808 15.3612 7.30446 15.1263 6.83111Z"
                      fill="url(#paint5_linear_176_439)"
                    />
                    <path
                      d="M51.8027 10.9513L56.4892 9.09526C56.9805 8.90068 57.532 9.14017 57.7211 9.63017C57.9102 10.1202 57.6652 10.6751 57.1739 10.8697L52.4875 12.7257C51.9962 12.9203 51.4446 12.6808 51.2555 12.1908C51.0664 11.7008 51.3114 11.1459 51.8027 10.9513Z"
                      fill="url(#paint6_linear_176_439)"
                    />
                    <path
                      d="M53.2436 14.8742L58.2797 15.0848C58.8077 15.1069 59.2142 15.55 59.1876 16.0745C59.161 16.5991 58.7115 17.0064 58.1835 16.9843L53.1474 16.7738C52.6194 16.7517 52.2129 16.3086 52.2395 15.784C52.2661 15.2595 52.7156 14.8521 53.2436 14.8742Z"
                      fill="url(#paint7_linear_176_439)"
                    />
                    <path
                      d="M48.606 8.04883L51.7365 4.09826C52.0647 3.6841 52.6621 3.61572 53.0709 3.94553C53.4796 4.27534 53.5449 4.87844 53.2167 5.2926L50.0862 9.24318C49.758 9.65734 49.1606 9.72572 48.7518 9.39591C48.3431 9.0661 48.2778 8.46299 48.606 8.04883Z"
                      fill="url(#paint8_linear_176_439)"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M27.3044 11.3795C27.1368 11.3917 26.9686 11.4082 26.8001 11.4289C21.1538 12.1222 17.1478 17.3364 17.8524 23.0753C17.9651 23.9931 18.1915 24.8688 18.5154 25.6895L18.5143 25.6926C20.0497 29.6808 22.891 35.1914 27.765 39.0794C29.209 38.7023 30.5699 38.4799 30.6307 38.4701L29.2529 27.2491C29.0895 27.2859 28.9228 27.3149 28.7531 27.3357C25.9762 27.6767 23.4478 25.6951 23.1058 22.9096C22.7638 20.1242 24.7377 17.5898 27.5145 17.2488C27.6843 17.228 27.8531 17.2158 28.0205 17.212L27.3044 11.3795Z"
                      fill="url(#paint9_linear_176_439)"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M24.9399 11.7183C24.7726 11.7307 24.6048 11.7471 24.4365 11.7678C18.7902 12.4611 14.7767 17.6144 15.4721 23.2781C15.6328 24.5866 16.0308 25.8079 16.6174 26.9039C19.7239 33.2724 27.7983 39.1472 27.7983 39.1472C27.7983 39.1472 27.9615 38.9574 28.2418 38.61L26.8551 27.316C26.6919 27.3528 26.5253 27.3818 26.3558 27.4026C23.5789 27.7435 21.0506 25.7619 20.7086 22.9765C20.3665 20.1911 22.3404 17.6566 25.1173 17.3157C25.2868 17.2949 25.4554 17.2827 25.6227 17.2789L24.9399 11.7183Z"
                      fill="url(#paint10_linear_176_439)"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M33.7989 11.6568C33.9667 11.6633 34.1353 11.674 34.3044 11.6888C39.9608 12.1836 44.1466 17.1511 43.6538 22.7839C43.5357 24.134 43.1596 25.3997 42.5779 26.5372C40.9217 30.3424 37.868 34.074 33.7141 38.7611C32.9238 38.4632 31.5793 37.9702 31.5793 37.9702C31.5793 37.9702 31.553 37.944 31.5035 37.8933L32.446 27.1207C32.6104 27.1518 32.7778 27.175 32.948 27.1899C35.7298 27.4332 38.1833 25.3624 38.4281 22.5646C38.6729 19.7667 36.6162 17.3013 33.8344 17.0579C33.6642 17.043 33.4953 17.0368 33.328 17.0389L33.7989 11.6568Z"
                      fill="url(#paint11_linear_176_439)"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36.0075 11.7924C36.1749 11.7989 36.3431 11.8095 36.5118 11.8242C42.1681 12.3191 46.35 17.3321 45.8523 23.0211C45.7378 24.3299 45.3856 25.5604 44.8422 26.6734C41.969 33.1573 34.1063 39.326 34.1063 39.326C34.1063 39.326 33.9366 39.1416 33.6444 38.8033L34.6368 27.4597C34.8011 27.4907 34.9684 27.5139 35.1384 27.5288C37.9202 27.7722 40.3737 25.7014 40.6185 22.9035C40.8633 20.1056 38.8066 17.6402 36.0248 17.3968C35.8548 17.382 35.686 17.3757 35.5189 17.3778L36.0075 11.7924Z"
                      fill="url(#paint12_linear_176_439)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_176_439"
                        x1="64.8891"
                        y1="61.0799"
                        x2="59.4697"
                        y2="48.3545"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#C8D4DE" stop-opacity="0.01" />
                        <stop offset="1" stopColor="#DEEAF4" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_176_439"
                        x1="-15.7415"
                        y1="44.4627"
                        x2="22.5739"
                        y2="76.7791"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#EFF6FF" />
                        <stop offset="1" stopColor="white" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_176_439"
                        x1="42.1619"
                        y1="44.7031"
                        x2="28.9671"
                        y2="33.6334"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#80C9C7" stop-opacity="0.01" />
                        <stop offset="1" stopColor="#3E80B3" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear_176_439"
                        x1="5.38321"
                        y1="6.63295"
                        x2="8.48295"
                        y2="12.225"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#E8F1F5" />
                        <stop offset="1" stopColor="#E5EAF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint4_linear_176_439"
                        x1="2.71338"
                        y1="12.8214"
                        x2="7.81963"
                        y2="16.6692"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#E8F1F5" />
                        <stop offset="1" stopColor="#E5EAF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint5_linear_176_439"
                        x1="11.1053"
                        y1="1.77062"
                        x2="10.9938"
                        y2="8.16337"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#E8F1F5" />
                        <stop offset="1" stopColor="#E5EAF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint6_linear_176_439"
                        x1="58.177"
                        y1="9.88115"
                        x2="53.9823"
                        y2="14.7066"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#E8F1F5" />
                        <stop offset="1" stopColor="#E5EAF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint7_linear_176_439"
                        x1="59.502"
                        y1="16.4893"
                        x2="53.7073"
                        y2="19.1914"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#E8F1F5" />
                        <stop offset="1" stopColor="#E5EAF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint8_linear_176_439"
                        x1="53.5912"
                        y1="3.93493"
                        x2="52.3712"
                        y2="10.2112"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#E8F1F5" />
                        <stop offset="1" stopColor="#E5EAF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint9_linear_176_439"
                        x1="18.8644"
                        y1="15.7599"
                        x2="35.4389"
                        y2="29.3181"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FF5E84" />
                        <stop offset="1" stopColor="#E46B80" />
                      </linearGradient>
                      <linearGradient
                        id="paint10_linear_176_439"
                        x1="7.81875"
                        y1="52.7655"
                        x2="28.1367"
                        y2="49.9166"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FFB8C6" />
                        <stop offset="1" stopColor="#FF8194" />
                      </linearGradient>
                      <linearGradient
                        id="paint11_linear_176_439"
                        x1="43.4202"
                        y1="19.2673"
                        x2="27.4514"
                        y2="28.7494"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FFCFD5" />
                        <stop offset="1" stopColor="#FFA2AB" />
                      </linearGradient>
                      <linearGradient
                        id="paint12_linear_176_439"
                        x1="55.2985"
                        y1="51.5483"
                        x2="34.8552"
                        y2="49.7597"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FFB8C6" />
                        <stop offset="1" stopColor="#FF8194" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <div className="absolute right-[-40px] top-[-60px] w-36 h-36 bg-white/50 rounded-full"></div>
                </div>
              </div>
            </div>
          </>
        )}
        {this.state.flagData && (
          <>
            <div className="px-4">
              <Masonry
                breakpointCols={{ default: 6, 680: 2 }}
                className="flex w-auto"
              >
                {this.state.dataTop.map((item, i) => {
                  return (
                    <div
                      key={i}
                      onClick={() => this.gotoDetail(item.alias)}
                      className="m-2 mb-4 break-inside-avoid rounded-xl shadow-md hover:shadow-lg cursor-pointer"
                    >
                      <div className="h-[130px] overflow-hidden">
                        <img
                          src={item.cover_file}
                          alt="cover buku"
                          className="w-full rounded-xl"
                        />
                      </div>
                      <div className="p-2">
                        <div className="title-book text-sm text-black font-semibold line-clamp-3">
                          {item.judul}
                        </div>
                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                          {item.penulis}
                        </div>
                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                          {item.penerbit}
                        </div>
                        <div className="stock mt-1 text-sm text-orange font-semibold">
                          Stok: {item.terpakai}/{item.qty}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Masonry>
            </div>

            <div className="text-center mb-16 h-[88px]">
              <button
                type="button"
                onClick={() =>
                  this.btnNext(this.state.lat, this.state.long, this.state.long)
                }
                className="mt-2 py-2 px-8 border-[1px] border-orange text-orange text-sm font-semibold text-center rounded-full"
              >
                Lihat Lebih Banyak
              </button>
            </div>
          </>
        )}
        {this.state.flagNoData && (
          <>
            <div className="pt-4 mb-4">
              <svg
                width="204"
                height="168"
                viewBox="0 0 204 168"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mx-auto"
              >
                <path
                  d="M7.51514 77.2217V78.9444"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M3.64648 78.1548L5.05412 79.6039"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M2 82.0122H3.99038"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M3.48535 85.9381L4.89299 84.4891"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M7.51514 86.4091V84.6865"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M10.3862 85.2607L9.23779 84.1123"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M12.6831 82.3896H10.9604"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M11.5347 78.3702L10.3862 79.5186"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M99.9629 2V3.14842"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M96.5181 5.44528H97.6665"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M99.9629 8.89055V7.74213"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M102.834 5.44528H101.686"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M33.3545 50.2338V51.9564"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M28.1865 55.4017H29.9092"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M33.3545 59.9954V58.2728"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M37.9482 55.4017H36.2256"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  d="M156.956 112.845C158.329 112.845 159.442 113.959 159.442 115.331C159.442 116.704 158.329 117.817 156.956 117.817C155.584 117.817 154.471 116.704 154.471 115.331"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M168.33 90.2928C169.806 89.8325 172.068 88.0279 172.591 86.0862C173.066 87.8026 175.056 89.8325 176.852 89.9861C174.831 90.7019 172.898 92.8284 172.591 94.4989C172.383 92.7962 169.709 90.541 168.33 90.2928Z"
                  fill="#EBECEE"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.8594 112.08C17.5974 111.849 18.7279 110.947 18.9897 109.977C19.2271 110.834 20.222 111.849 21.12 111.927C20.1094 112.284 19.1432 113.347 18.9897 114.183C18.8853 113.331 17.5487 112.203 16.8594 112.08Z"
                  fill="#EBECEE"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M30.5557 32.2019C30.5557 33.2668 29.6928 34.1294 28.6287 34.1294C27.564 34.1294 26.7017 33.2668 26.7017 32.2019C26.7017 31.1375 27.564 30.2744 28.6287 30.2744C29.6928 30.2744 30.5557 31.1375 30.5557 32.2019Z"
                  fill="#D1D8DF"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M159.233 37.3776C159.233 39.1569 157.791 40.5992 156.012 40.5992C154.233 40.5992 152.791 39.1569 152.791 37.3776C152.791 35.5983 154.233 34.1559 156.012 34.1559C157.791 34.1559 159.233 35.5983 159.233 37.3776Z"
                  fill="#EBECEE"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M203.847 28.649C203.847 30.0606 202.703 31.2045 201.293 31.2045C199.881 31.2045 198.738 30.0606 198.738 28.649C198.738 27.2373 199.881 26.0934 201.293 26.0934C202.703 26.0934 203.847 27.2373 203.847 28.649Z"
                  fill="#EBECEE"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M66.5694 148.004C66.5694 148.893 65.8484 149.615 64.9588 149.615C64.0696 149.615 63.3486 148.893 63.3486 148.004C63.3486 147.114 64.0696 146.392 64.9588 146.392C65.8484 146.392 66.5694 147.114 66.5694 148.004Z"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M65.6114 19.8188C65.6114 20.8837 64.7485 21.7463 63.6843 21.7463C62.6202 21.7463 61.7573 20.8837 61.7573 19.8188C61.7573 18.7543 62.6202 17.8913 63.6843 17.8913C64.7485 17.8913 65.6114 18.7543 65.6114 19.8188Z"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M114.766 165.843C113.534 166.312 112.156 165.693 111.688 164.462C111.219 163.23 111.837 161.851 113.069 161.383C114.3 160.915 115.678 161.533 116.147 162.765C116.616 163.996 115.997 165.375 114.766 165.843Z"
                  stroke="#D2D8DF"
                  strokeWidth="2.921"
                  stroke-linecap="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M114.032 120.288H66.9442C63.6299 120.288 60.917 117.567 60.917 114.241V47.0914C60.917 43.766 63.6299 41.0464 66.9442 41.0464H114.032C117.348 41.0464 120.061 43.766 120.061 47.0914V114.241C120.061 117.567 117.348 120.288 114.032 120.288Z"
                  fill="#E0E2EE"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M110.013 123.159H62.9247C59.6104 123.159 56.8975 120.438 56.8975 117.112V49.9625C56.8975 46.637 59.6104 43.9174 62.9247 43.9174H110.013C113.328 43.9174 116.041 46.637 116.041 49.9625V117.112C116.041 120.438 113.328 123.159 110.013 123.159Z"
                  fill="#E8EBF2"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M106.103 125.425H58.9176C55.5965 125.425 52.8779 122.716 52.8779 119.404V52.5321C52.8779 49.2204 55.5965 46.5121 58.9176 46.5121H106.103C109.425 46.5121 112.144 49.2204 112.144 52.5321V119.404C112.144 122.716 109.425 125.425 106.103 125.425Z"
                  fill="#D8DBEA"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M106.103 125.425H58.9176C55.5965 125.425 52.8779 122.716 52.8779 119.404V52.5321C52.8779 49.2204 55.5965 46.5121 58.9176 46.5121H106.103C109.425 46.5121 112.144 49.2204 112.144 52.5321V119.404C112.144 122.716 109.425 125.425 106.103 125.425Z"
                  fill="#F1F2F7"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M99.3018 97.8934H64.4497C63.4544 97.8934 62.6396 97.1183 62.6396 96.1714C62.6396 95.2232 63.4544 94.4481 64.4497 94.4481H99.3018C100.297 94.4481 101.112 95.2232 101.112 96.1714C101.112 97.1183 100.297 97.8934 99.3018 97.8934Z"
                  fill="#E0E2EE"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M82.6419 108.229H64.4574C63.4578 108.229 62.6396 107.454 62.6396 106.507C62.6396 105.559 63.4578 104.784 64.4574 104.784H82.6419C83.6415 104.784 84.4597 105.559 84.4597 106.507C84.4597 107.454 83.6415 108.229 82.6419 108.229Z"
                  fill="#E0E2EE"
                />
                <rect
                  x="62.8667"
                  y="55.4017"
                  width="38.4722"
                  height="31.0074"
                  rx="9"
                  fill="#E7E9F5"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M119.346 94.8712C112.377 101.839 101.588 102.625 93.7551 97.2454C92.754 96.5456 91.8013 95.7595 90.9128 94.8712C90.4554 94.4153 90.0243 93.9448 89.6181 93.4495C88.8056 92.4604 88.0939 91.4055 87.5108 90.3155C86.4835 88.4746 85.785 86.5211 85.4036 84.5019C84.1732 78.1697 86.013 71.3538 90.9128 66.4563C95.8243 61.5441 102.641 59.7163 108.975 60.9349C110.993 61.3279 112.948 62.0263 114.789 63.0417C115.881 63.6378 116.921 64.3494 117.912 65.1617C118.406 65.5665 118.877 65.9989 119.333 66.4563C120.222 67.3446 121.02 68.2957 121.707 69.298C127.089 77.1279 126.302 87.9165 119.346 94.8712Z"
                  fill="white"
                  fill-opacity="0.1"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M117.396 93.4988C110.145 100.751 98.3954 100.749 91.1437 93.4988C83.9015 86.2566 83.9015 74.5055 91.1532 67.2551C98.3954 60.0129 110.145 60.0129 117.387 67.2551C124.638 74.5055 124.638 86.2566 117.396 93.4988ZM121.116 63.5299C111.81 54.2235 96.7292 54.2235 87.4228 63.5299C78.1177 72.835 78.1096 87.9253 87.4147 97.2318C95.8847 105.699 109.16 106.463 118.498 99.5105C119.41 98.8305 120.288 98.0682 121.126 97.2318C121.962 96.3939 122.725 95.5156 123.403 94.6036C130.355 85.2648 129.585 71.9986 121.116 63.5299Z"
                  fill="#E0E2EE"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M157.742 132.313L157.351 132.703C154.766 135.289 150.533 135.289 147.947 132.703L124.08 108.836L133.875 99.0418L157.742 122.909C160.328 125.495 160.328 129.726 157.742 132.313Z"
                  fill="url(#paint0_linear_107_235)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M123.918 93.8739L130.971 100.927L125.964 105.932L118.912 98.8795C119.843 98.1857 120.738 97.4078 121.594 96.5543C122.447 95.7007 123.225 94.8045 123.918 93.8739Z"
                  fill="#E0E2EE"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M157.384 122.615L147.652 132.346L145.9 130.593L155.631 120.862L157.384 122.615Z"
                  fill="#EF545F"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M134.416 99.3788L124.417 109.378L122.932 107.892L132.93 97.8934L134.416 99.3788Z"
                  fill="url(#paint1_linear_107_235)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M112.596 64.7606L88.075 89.2802C87.1516 87.6252 86.5237 85.869 86.1821 84.0537L107.369 62.8665C109.183 63.2211 110.941 63.8477 112.596 64.7606Z"
                  fill="white"
                  fill-opacity="0.5"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M120.635 70.5887L94.1252 95.5965C93.1758 94.9715 92.2722 94.2681 91.4296 93.4732C90.9958 93.064 90.5856 92.6443 90.2017 92.201L117.034 66.8859C117.504 67.2494 117.95 67.6364 118.383 68.0456C119.225 68.8406 119.984 69.6917 120.635 70.5887Z"
                  fill="white"
                  fill-opacity="0.5"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_107_235"
                    x1="141.881"
                    y1="81.2412"
                    x2="106.28"
                    y2="116.842"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#FF8960" />
                    <stop offset="1" stopColor="#FF62A5" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_107_235"
                    x1="128.674"
                    y1="92.1513"
                    x2="117.19"
                    y2="103.635"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#FF404E" />
                    <stop offset="1" stopColor="#FF62A5" />
                  </linearGradient>
                </defs>
              </svg>
              <div className="px-8 mt-6 mb-6 text-center">
                <h3 className="text-black text-lg font-semibold">
                  {this.state.msgTitleNoData}
                </h3>
                <p className="mt-4 text-sm text-gray-light">
                  {this.state.msgNoData}
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default WithNavigate;
